// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['colaborador_satya']



const clientesSatyaBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Clientes Satya',
    to: 'ClientesSatya'
  }
]

export default [
  {
    path: '/clientesSatya',
    name: 'ClientesSatya',
    component: () => import('@/views/ClientesSatya/ClienteSatyaListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Clientes Satya',
      breadcrumb: clientesSatyaBreadCrumb
    },
  },
  {
    path: '/clientesSatya/novo',
    name: 'ClienteSatyaNovo',
    component: () => import('@/views/ClientesSatya/NovoClienteSatyaPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Cliente Satya',
      breadcrumb: [
        ...clientesSatyaBreadCrumb,
        {
          label: 'Novo Cliente Satya',
          to: 'ClienteSatyaNovo'
        }
      ]
    }
  },
  {
    path: '/clientesSatya/:id/detalhes',
    name: 'ClienteSatyaDetalhes',
    component: () => import('@/views/ClientesSatya/NovoClienteSatyaPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes do Cliente Satya',
      breadcrumb: [
        ...clientesSatyaBreadCrumb,
        {
          label: 'Detalhes do Cliente Satya',
          to: 'ClienteSatyaNovo'
        }
      ]
    }
  }
];
